import { FC } from 'react';

import { CSSProperties } from 'styled-components';
import { Collapse as ChakraCollapse } from '@chakra-ui/react';

import { withIsMounted } from '~/shared/utils/withIsMounted';

interface ICollapseProps {
  isOpen?: boolean;
  contentStyle?: CSSProperties;
  startingHeight?: number;
}

export const Collapse: FC<ICollapseProps> = withIsMounted(
  ({ isOpen = false, children, contentStyle, startingHeight }) => {
    return (
      <ChakraCollapse
        in={isOpen}
        animateOpacity
        style={contentStyle}
        startingHeight={startingHeight}
      >
        {children}
      </ChakraCollapse>
    );
  }
);
